import initializeProviders from './util/initializeProviders';
import { getLogger } from '@indeed/mosaic-provider-utils/dist/web/logger';
import { MosaicLogger } from './util/logging';
/**
 * The main method for dynamically adding the central Provider dependencies, and Provider JavaScript bundles
 * to the DOM asynchronously, with proper error handling and instrumentation.
 */
try {
    (() => {
        const logger = new MosaicLogger(window.mosaic, getLogger('uip-common'));
        try {
            window.mosaic._loadProviders = (providerScripts, providerTranslations) => {
                window.mosaic.onReady = initializeProviders(providerScripts, providerTranslations, logger, window.mosaic.onReady);
                return window.mosaic.onReady;
            };
            window.mosaic
                ._loadProviders(window.mosaic.providers, window.mosaic.provideri18N)
                .catch((e) => logger.trackError('jsuipPlatformInitError', e));
        }
        catch (e) {
            logger.trackError('jsuipPlatformInitError', e);
        }
    })();
}
catch (e) {
    // TODO something happened and logging isn't available, what should we do?
    // make a http request to the host app?
}
